// client/src/dnd/emitter_tool/engine/engine_parts/sprites/AnimSource.js
import * as PIXI from "pixi.js";

/**
 * AnimSource
 * Advances through list[] at a fixed fps using accumulated dt.
 */
export default class AnimSource {
  /**
   * @param {Object} opts
   * @param {Record<string, PIXI.Texture>} opts.textures
   * @param {string[]} opts.list
   * @param {number} opts.fps
   * @param {boolean} [opts.loop=true]
   */
  constructor({ textures = {}, list = [], fps = 12, loop = true } = {}) {
    this.textures = textures;
    this.frames = Array.isArray(list) ? list.filter((n) => textures[n]) : [];
    if (!this.frames.length) this.frames = Object.keys(textures || {});
    this.fps = Math.max(1, Math.min(120, Math.floor(Number(fps) || 12)));
    this.loop = loop !== false;

    this._timer = 0;
    this._index = 0;
    this._step = 1 / this.fps;
  }

  /** @param {number} dt seconds since last call */
  next(dt = 0) {
    const list = this.frames;
    if (!list.length) return PIXI.Texture.WHITE;

    this._timer += Number.isFinite(dt) ? dt : 0;
    while (this._timer >= this._step) {
      this._timer -= this._step;
      if (this._index + 1 < list.length) {
        this._index += 1;
      } else if (this.loop) {
        this._index = 0;
      } // else stay on last frame
    }

    const name = list[this._index] || list[0];
    return this.textures[name] || PIXI.Texture.WHITE;
  }
}
